import { B as k, j as i } from "./Spinner-dTAYYnIx.js";
import { useState as m, useRef as S, useEffect as T } from "react";
import { styled as x } from "styled-components";
import { o as E, T as L, d as O, j as P, e as q } from "./style-8UHgYe1v.js";
import { e as h } from "./index-QRkynDgW.js";
import { u as z } from "./useTransitionState-9D4Z4_FK.js";
import { u as I } from "./useResizeObserver-ghdBe7Hs.js";
import { P as M } from "./icon-plus-zj7j8_QD.js";
import { g as W } from "./_commonjsHelpers-OnjxAlhP.js";
import { s as G } from "./scrollIntoViewIfNeeded-xuoxAk9g.js";
const N = x(k)`
  ${E(L.bodySMedium)}
  padding: ${h.spacer4} ${h.spacer1};

  [data-whatintent='keyboard'] &:focus-within {
    outline: 1px solid;
    ${O("outline-color", "dominant")};
    outline-offset: -1px;
  }
`, A = x.div`
  ${P("height, opacity", q.shorter)};
  position: relative;
  opacity: ${({ $height: o }) => o ? 1 : 0};
  width: 100%;
  height: ${({ $height: o, $inTransition: a }) => a ? `${o}px` : "auto"};
  overflow: hidden;
`, Y = ({
  children: o,
  t: a,
  onChange: c,
  isCollapsable: $ = !0,
  buttonVariant: d = "icon",
  focusTargetSelector: p = null
}) => {
  const { showMoreLabel: w, showLessLabel: y } = a, [{ height: u }, g] = I(), [e, b] = m(!1), [s, r, j] = z(e, ["height"]), l = S(null), [f, v] = m(!1), B = (n) => {
    b((t) => !t), v(!0), c == null || c(n);
  };
  T(() => {
    const { document: n } = W();
    if (n) {
      if (e && !s && p) {
        const t = n.querySelectorAll(p)[0];
        t && (t == null || t.focus());
      }
      !e && !s && f && l.current && G(l.current);
    }
  }, [e, s, f]);
  const R = () => /* @__PURE__ */ i.jsx(
    N,
    {
      ref: l,
      "aria-expanded": e,
      "data-qa": "show-all-button",
      variant: d,
      icon: d === "icon" ? { icon: M, size: "sm" } : void 0,
      onClick: B,
      children: r ? y : w
    }
  );
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    (r || s) && /* @__PURE__ */ i.jsx(
      A,
      {
        $inTransition: s,
        $height: r && u ? u : 0,
        onTransitionEnd: j,
        role: "region",
        children: /* @__PURE__ */ i.jsx("div", { ref: g, children: o })
      }
    ),
    ($ || !r) && R()
  ] });
};
export {
  Y as S
};
